const indexRegex = /^[0-9]+$/
const isIndex = (str) => typeof str === 'number' || indexRegex.test(str)

export default isIndex
